// src/api.js
const API_URL = "https://admin.serbiantrophy.rs";

export const getToken = () => localStorage.getItem("st_admin_token") || "";
export const setToken = (t) => localStorage.setItem("st_admin_token", t);
export const clearToken = () => localStorage.removeItem("st_admin_token");

export async function api(path, opts = {}) {
  const {
    method = "GET",
    body,
    headers = {},
    auth = false, // set true for admin endpoints
  } = opts;

  const h = { "Content-Type": "application/json", ...headers };
  if (auth) {
    const token = getToken();
    if (token) h.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: h,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || res.statusText);
  }

  return res.json();
}
